import { Box } from '@mui/material';
import { FC } from 'react';
import styles from './styles.module.scss';
import {
  HeadSection,
  InfoSection,
  ReasonsSection,
  PreferenceSection,
  CompliantSection,
} from './components';
import {
  CustomerFeedbackSection,
  ExtensionPromoSection,
  Breadcrumbs,
} from '@/components';
import { useTranslation } from 'next-i18next';
import { ROUTES } from '@/libs/routing';

export const OurData: FC = () => {
  const { t } = useTranslation('common');

  return (
    <Box className={styles.pageRoot}>
      <Breadcrumbs
        float
        items={[{ label: t('header.nav.unlimitedData.title'), url: ROUTES.OUR_DATA }]}
      />
      <HeadSection />
      <InfoSection />
      <ReasonsSection />
      <PreferenceSection />
      <CustomerFeedbackSection variant="grey" />
      <CompliantSection />
      <ExtensionPromoSection />
    </Box>
  );
};
